import {FRAME_CHARGER_SERIAL} from '../../consts/scp/scpFrames';
import pairingService from '../pairingService';
import connectivityService from './connectivityService';
import framesProcessingService from './framesProcessingService';

// This scheduler is used to ping device until first frames come form CM
// it prevents the device from sleeping

const PING_CHARGER_SCHEDULER_INTERVAL_MS = 3000;

let pingSchedulerInterval;

const startPing = () => {
    const isUsb = connectivityService.isUsb();

    if (pingSchedulerInterval || isUsb) return;

    pingSchedulerInterval = setInterval(() => {
        const isDeviceConnected = pairingService.isDeviceConnected();

        if (!isDeviceConnected) {
            stopPing();
            return;
        }

        framesProcessingService.processFrames({
            frames: [FRAME_CHARGER_SERIAL],
            retryCount: 0,
        });
    }, PING_CHARGER_SCHEDULER_INTERVAL_MS);
};

const stopPing = () => {
    if (!pingSchedulerInterval) return;
    clearInterval(pingSchedulerInterval);
    pingSchedulerInterval = null;
};

export default {
    stopPing,
    startPing,
};
